<template>
  <div class="content">
    <p class="heading">
      香の川製麺のメニューがお家でも楽しめる♪<br>
      香の川製麺公式ネットショップが<br>
      オープンしました。
    </p>
    <a href="https://amzn.to/2OO03Cv" class="net-shop" @click.native="() => { trapTrackNetShopEvent('Amazon') }">
      <img :src="require('@/assets/img/net-shop/amazon.png')" alt="" class="amazon">
    </a>
    <a href="https://bit.ly/3585912" class="net-shop" @click.native="() => { trapTrackNetShopEvent('Rakuten') }">
      <img :src="require('@/assets/img/net-shop/rakuten.png')" alt="" class="rakuten">
    </a>
    <a href="https://bit.ly/3eOY5wq" class="net-shop" @click.native="() => { trapTrackNetShopEvent('yahoo') }">
      <img :src="require('@/assets/img/net-shop/yahoo.png')" alt="" class="yahoo">
    </a>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { FactoryTrack } from '@/constant/firebase'

export default {
  name: 'NetShopNetStore',
  data() {
    return {
      title: 'ネットストア'
    }
  },
  created() {
  },
  methods: {
    ...mapActions('Native', ['actionRequestExternalLink']),
    ...mapActions('Analytics', ['trackEvent']),
    openNetStore(url) {
      this.actionRequestExternalLink(url)
    },
    trapTrackNetShopEvent(caption) {
      this.trackEvent(FactoryTrack.createNetShop(caption))
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;

  .heading {
    font-size: 15px;
    font-weight: bold;
    color: #66160E;
    margin-bottom: 20px;
  }

  .net-shop {
    width: 100%;
    height: 70px;
    background: #ffffff;
    border: 1px solid #5f230e;
    border-radius: 7px;
    box-shadow: 0 2px 1px 0 #d4d2cc;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 90%;
      max-width: 267px;
    }

    &.coming-soon {
      background: #cccccc;
      border: 1px solid #cccccc;
      box-shadow: none;
      color: #ffffff;
      font-weight: bold;
    }

    &.bk {
      background: #000000;
      border: 1px solid #000000;

    }
  }
}

</style>
